<template>
    <svg version="1.1" :class="color === 'primary' ? 'box_hex_color' : 'box_hex'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="74.35px"
      height="25.98px" viewBox="0 0 74.35 25.98" style="enable-background:new 0 0 74.35 25.98;" xml:space="preserve">
      <polygon class="polygon" points="0,25.98 0,8.66 15,0 74.35,0 74.35,17.32 59.35,25.98 "/>
      <linearGradient id="blue-to-green" x2="1" y2="1">
        <stop offset="0%" stop-color="#51b3e3" />
        <stop offset="100%" stop-color="#83c06f" />
      </linearGradient>
    </svg>
</template>

<script>
export default {
  props: ["color"]
};
</script>

<style scoped>
.box_hex {
  position: absolute;
  background: transparent;
  transition: 0.4s;
  fill: #212121;
  transform: scale(1.7);
  filter: drop-shadow(rgba(0, 0, 0, 0.5) 0px 0px 4px);
}
.box_hex_color {
  position: absolute;
  background: transparent;
  transition: 0.4s;
  transform: scale(1.7);
  /* background: linear-gradient(45deg, #51b3e3 0%,#83c06f 100%); */
  fill: url("#blue-to-green") !important;
  filter: drop-shadow(rgba(0, 0, 0, 0.5) 0px 0px 4px);
}
.text_hex {
  z-index: 100;
}
</style>
